import React from "react";
import { IconWhatsApp } from "../components/Icons";
import ServiciosMarquee from "../components/Marquee";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { SecondaryLink } from "../components/Links";
import { WhatsAppFloating } from "./Layout";

export default function LandingPage() {
  const testimonials = [
    {
      text: "Me comuniqué y el plomero me llamó en menos de una hora para coordinar la visita. Fue súper prolijo, educado y dejó todo impecable. Muy buen servicio.",
      author: "Carla",
      location: "Caballito",
    },
    {
      text: "Busqué por Google y en minutos me escribieron por WhatsApp. Tenía una pérdida en el baño y no conseguía nadie de confianza para solucionarlo. Me mandaron un plomero al otro día y el trabajo quedó perfecto.",
      author: "Laura",
      location: "Palermo",
    },
    {
      text: "Lo que más me gustó es que hablé con una persona, no con un bot. Me explicaron todo con claridad y el electricista que vino muy recomendable. Resolvió todo sin dar vueltas ni agregar cosas demás.",
      author: "Martín",
      location: "Belgrano",
    },
    {
      text: "Se me trabó la persiana del cuarto y no sabía a quien llamar. Hablé con Sabrina y en menos de 3 horas mandaron un técnico a mi casa. Muy amable, todo resuelto, sin vueltas y más barato de lo que pensé.",
      author: "Federico",
      location: "Barracas",
    },
  ];

  const whatsappNumber = "5491150981730";
  const whatsappMessage = encodeURIComponent(
    "¡Hola! Quiero solicitar mi primer servicio en Soluciones Hogar"
  );

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <div className="min-h-screen font-sans text-gray-900">
      <header className="fixed w-full top-0 shadow-md bg-white z-50">
        <div className="w-full px-6 flex flex-row justify-between items-center py-4 h-16">
          <Link to="/">
            <img
              src="/logo.svg"
              alt="Logo Soluciones Hogar"
              className="h-9 w-auto"
            />
          </Link>
        </div>
      </header>

      <section className="relative min-h-screen bg-cover bg-center flex items-center justify-center bg-white/60">
        <div className="container flex flex-col items-center mx-auto px-4 text-center max-w-3xl gap-4">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-secondary">
            Hacé tu primer pedido y conocenos
          </h1>
          <p className="text-xl md:text-2xl text-gray-700">
            Solucioná los problemas de tu casa sin estrés y con técnicos
            seleccionados de confianza
          </p>
          <div className="flex items-center gap-1 mb-4">
            <svg
              className="h-5 w-5 text-secondary"
              fill="#1d2d44"
              viewBox="0 0 32 32"
            >
              <path d="M16.114-0.011c-6.559 0-12.114 5.587-12.114 12.204 0 6.93 6.439 14.017 10.77 18.998 0.017 0.020 0.717 0.797 1.579 0.797h0.076c0.863 0 1.558-0.777 1.575-0.797 4.064-4.672 10-12.377 10-18.998 0-6.618-4.333-12.204-11.886-12.204zM16.515 29.849c-0.035 0.035-0.086 0.074-0.131 0.107-0.046-0.032-0.096-0.072-0.133-0.107l-0.523-0.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zM16.035 6.044c-3.313 0-6 2.686-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zM16.035 16.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 0.001 2.206-1.747 4.044-3.954 4.044z"></path>
            </svg>
            <span>CABA</span>
          </div>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-8 py-4 text-lg font-semibold text-white hover:bg-green-700 transition"
          >
            <IconWhatsApp className="h-6 w-6" />
            Contactanos por WhatsApp
          </a>
        </div>
        <img
          className="absolute w-full h-full object-cover object-bottom -z-20"
          src="/chica-sonriendo.jpg"
          alt="tecnico "
        />
      </section>

      <ServiciosMarquee />

      <section className="py-12 md:py-16">
        <div className="container mx-auto px-4 grid gap-8 md:grid-cols-3">
          {[
            {
              icon: (
                <svg
                  width="64px"
                  height="64px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                    stroke="#ff9e1b"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>{" "}
                  <path
                    d="M12 6V12"
                    stroke="#ff9e1b"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>{" "}
                  <path
                    d="M16.24 16.24L12 12"
                    stroke="#ff9e1b"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>{" "}
                </svg>
              ),
              title: "Experiencia y trayectoria",
              text: "Más de 30 años de respaldo.",
            },
            {
              icon: (
                <svg
                  fill="#ff9e1b"
                  width="64px"
                  height="64px"
                  viewBox="0 0 35 35"
                  data-name="Layer 2"
                  id="Layer_2"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.5,34.44A3.07,3.07,0,0,1,15.89,34L9.82,30.45A14.79,14.79,0,0,1,2.25,17.7V8A3.2,3.2,0,0,1,4.34,5L16.4.57a3.2,3.2,0,0,1,2.2,0L30.66,5a3.2,3.2,0,0,1,2.09,3V17.7a14.79,14.79,0,0,1-7.57,12.75L19.11,34A3.07,3.07,0,0,1,17.5,34.44Zm0-31.56a.67.67,0,0,0-.24,0L5.2,7.33A.69.69,0,0,0,4.75,8V17.7a12.3,12.3,0,0,0,6.33,10.59l6.07,3.56a.73.73,0,0,0,.7,0l6.07-3.56h0A12.3,12.3,0,0,0,30.25,17.7V8a.69.69,0,0,0-.45-.65L17.74,2.92A.67.67,0,0,0,17.5,2.88Z"></path>
                  <path d="M16.4,22.35a1.3,1.3,0,0,1-.81-.29l-4.27-3.6a1.25,1.25,0,0,1,1.61-1.92l3.35,2.82L22,13.06a1.25,1.25,0,0,1,1.86,1.68l-6.48,7.2A1.27,1.27,0,0,1,16.4,22.35Z"></path>
                </svg>
              ),
              title: "Doble garantía",
              text: " Calidad asegurada en cada trabajo.",
            },
            {
              icon: (
                <svg
                  width="64px"
                  height="64px"
                  viewBox="0 0 20 20"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ff9e1b"
                >
                  <path d="M 10,0 9.6054688,0.015625 9.2148438,0.0625 8.828125,0.13867188 8.4492188,0.24414062 8.078125,0.38085938 7.7207031,0.54492188 7.3769531,0.73632812 7.0488281,0.95507812 6.7382812,1.1972656 6.4492188,1.4648438 6.1816406,1.7539062 5.9375,2.0605469 5.71875,2.3867188 5.5253906,2.7304688 5.359375,3.0859375 5.2246094,3.4550781 5.1171875,3.8339844 5.0390625,4.21875 4.9941406,4.609375 4.9785156,5 4.9941406,5.6132812 5.0371094,6.2246094 5.1132812,6.8320312 5.21875,7.4355469 5.3535156,8.0332031 5.5175781,8.625 l 0.1914063,0.5800781 0.2207031,0.5722657 0.25,0.5585942 0.2753906,0.548828 0.1835938,0.308593 0.2089843,0.291016 0.0625,0.09766 0.037109,0.107422 0.00977,0.115235 -0.015625,0.115234 -0.042969,0.105469 -0.0625,0.0957 -0.085937,0.07617 -0.1015625,0.05664 -0.109375,0.0332 -0.7207031,0.132813 -0.7128906,0.15625 -0.7089844,0.179687 -0.7011719,0.205079 -0.6933594,0.230468 -0.6855469,0.253906 -0.2792968,0.125 -0.2636719,0.152344 -0.2480469,0.179688 -0.2285156,0.201172 -0.2050781,0.224609 -0.18164065,0.242187 -0.15625,0.261719 L 0.62304688,15.107422 0.4453125,15.578125 0.29492188,16.056641 0.171875,16.542969 0.07617187,17.035156 0.0078125,17.53125 0,17.736328 0.01953125,17.9375 l 0.046875,0.197266 0.07226563,0.189453 0.0976562,0.177734 0.11914063,0.164063 L 0.5,18.810547 l 0.15820312,0.125 0.17773438,0.101562 0.1875,0.08008 0.1972656,0.04883 1.1582031,0.208984 1.1640626,0.177734 1.1679687,0.148438 1.171875,0.11914 1.1738281,0.08984 1.1777344,0.06055 L 9.4121094,20 H 10.458984 L 9.4589844,19 H 9.421875 L 8.2714844,18.970703 7.1210938,18.912109 5.9726562,18.826172 4.8242188,18.708984 3.6835938,18.5625 2.5429688,18.388672 1.4101562,18.185547 l -0.1171874,-0.03906 -0.1074219,-0.06445 -0.083984,-0.0918 -0.060547,-0.105468 -0.033203,-0.121094 -0.00195,-0.123047 0.0625,-0.443359 0.083984,-0.435547 0.109375,-0.433594 0.1328124,-0.425781 0.1582032,-0.417969 0.1015625,-0.207031 0.1230469,-0.199219 0.1445312,-0.179687 0.1660156,-0.16211 0.1835938,-0.142578 0.1992187,-0.121094 0.2109375,-0.0957 0.6523438,-0.242187 0.6601562,-0.21875 0.6679688,-0.195313 0.6757812,-0.171875 0.6796875,-0.148437 0.6835938,-0.126953 0.2167969,-0.05274 0.2070312,-0.08398 0.1933594,-0.113281 0.171875,-0.140626 0.1484375,-0.164062 0.1269531,-0.183594 0.09375,-0.201172 0.064453,-0.21289 0.033203,-0.21875 v -0.222656 l -0.035156,-0.21875 -0.064453,-0.212891 -0.095703,-0.201172 -0.125,-0.183594 L 7.4785156,10.644531 7.3417969,10.414062 7.0859375,9.9101562 6.8574219,9.3945312 6.6542969,8.8691406 6.4785156,8.3339844 6.328125,7.7910156 6.203125,7.2402344 6.1074219,6.6855469 6.0371094,6.1269531 5.9960938,5.5644531 5.9804688,5.0019531 5.9980469,4.6523438 6.0429688,4.3066406 6.1191406,3.9667969 6.2246094,3.6328125 6.359375,3.3105469 6.5195312,3 6.7089844,2.7070312 6.921875,2.4296875 7.1582031,2.171875 7.4179688,1.9355469 7.6953125,1.7246094 7.9902344,1.5371094 8.3007812,1.375 8.625,1.2421875 8.9589844,1.1367188 9.3027344,1.0625 9.6503906,1.015625 9.9980469,1 10.349609,1.015625 10.697266,1.0625 l 0.341796,0.074219 0.333985,0.1054687 0.324219,0.1328125 0.3125,0.1621094 0.294922,0.1875 0.277343,0.2109375 0.259766,0.2363281 0.234375,0.2578125 0.214844,0.2773437 L 13.480469,3 l 0.160156,0.3105469 0.134766,0.3222656 0.105468,0.3339844 0.07617,0.3398437 0.04492,0.3457032 0.01563,0.3496093 -0.01367,0.5625 -0.04101,0.5625 -0.07031,0.5585938 -0.09766,0.5546875 -0.123047,0.5507812 -0.150391,0.5429688 -0.175781,0.5351562 -0.205078,0.5253906 -0.228516,0.515625 -0.253906,0.5039058 -0.136719,0.230469 -0.158203,0.21875 -0.126953,0.183594 -0.09375,0.201172 -0.06641,0.212891 -0.03516,0.21875 v 0.222656 l 0.0332,0.21875 0.06445,0.21289 0.0957,0.201172 0.125,0.183594 0.148437,0.164062 0.173829,0.140626 0.193359,0.113281 0.207031,0.08398 0.214844,0.05274 0.685547,0.126953 0.679687,0.148437 0.673829,0.171875 0.310546,0.0918 0.802735,-0.802734 -0.144531,-0.04883 -0.701172,-0.205079 -0.707032,-0.179687 -0.71289,-0.15625 -0.720703,-0.132813 -0.111329,-0.0332 -0.101562,-0.05664 -0.08398,-0.07617 -0.06445,-0.0957 -0.04101,-0.105469 -0.01758,-0.115234 0.01172,-0.115235 0.03711,-0.107422 0.06055,-0.09766 0.210937,-0.291016 0.183594,-0.308593 0.275391,-0.548828 L 14.070312,9.7773438 14.291016,9.2050781 14.484375,8.625 14.648438,8.0332031 14.783203,7.4355469 14.886719,6.8320312 14.962891,6.2246094 15.007812,5.6132812 15.021484,5 15.007812,4.609375 14.960938,4.21875 14.882812,3.8339844 14.777344,3.4550781 14.640625,3.0859375 14.474609,2.7304688 14.283203,2.3867188 14.064453,2.0605469 13.818359,1.7539062 13.552734,1.4648438 13.263672,1.1972656 12.953125,0.95507812 12.625,0.73632812 12.279297,0.54492188 11.921875,0.38085938 11.552734,0.24414062 11.173828,0.13867188 10.785156,0.0625 10.394531,0.015625 Z m 9.484375,12.996094 c -0.12976,0.0036 -0.25303,0.05754 -0.34375,0.15039 l -5.646484,5.646485 -2.646485,-2.646485 c -0.471255,-0.490806 -1.1978378,0.235778 -0.707031,0.707032 l 3,3 c 0.195265,0.195184 0.511766,0.195184 0.707031,0 l 6,-6 c 0.32527,-0.318003 0.09144,-0.869893 -0.363281,-0.857422 z"></path>
                </svg>
              ),
              title: "Técnicos verificados",
              text: " Profesionales confiables y con experiencia.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="border border-orange-200 bg-white p-6 text-center rounded-lg shadow-sm"
            >
              <div className="mb-4 flex justify-center">
                <div className="rounded-full bg-orange-100 p-4">
                  {item.icon}
                </div>
              </div>
              <h3 className="mb-2 text-xl font-bold text-primary">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-20">
            Servicios más solicitados
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8 justify-items-center">
            <div className="flex flex-col items-center gap-2 text-gray-700 hover:text-orange-600 transition">
              <img
                src="/iconos/grifo.png"
                alt="Plomería"
                className="h-10 w-10 object-contain transition-transform hover:scale-110"
              />
              <span className="font-medium mt-1">Plomería</span>
            </div>

            <div className="flex flex-col items-center gap-2 text-gray-700 hover:text-orange-600 transition">
              <img
                src="/iconos/enchufe.png"
                alt="Electricidad"
                className="h-10 w-10 object-contain transition-transform hover:scale-110"
              />
              <span className="font-medium mt-1">Electricidad</span>
            </div>

            <div className="flex flex-col items-center gap-2 text-orange-600 font-semibold">
              <img
                src="/iconos/gasista.png"
                alt="Gasistas"
                className="h-10 w-10 object-contain transition-transform hover:scale-110"
              />
              <span className="mt-1">Gasistas</span>
            </div>

            <div className="flex flex-col items-center gap-2 text-gray-700 hover:text-orange-600 transition">
              <img
                src="/iconos/persiana.png"
                alt="Persianas"
                className="h-10 w-10 object-contain transition-transform hover:scale-110"
              />
              <span className="font-medium mt-1">Persianas</span>
            </div>

            <div className="flex flex-col items-center gap-2 text-gray-700 hover:text-orange-600 transition">
              <img
                src="/iconos/cerrajero.png"
                alt="Cerrajería"
                className="h-10 w-10 object-contain transition-transform hover:scale-110"
              />
              <span className="font-medium mt-1">Cerrajería</span>
            </div>

            <div className="flex flex-col items-center gap-2 text-gray-700 hover:text-orange-600 transition">
              <img
                src="/iconos/destapador.png"
                alt="Destapaciones"
                className="h-10 w-10 object-contain transition-transform hover:scale-110"
              />
              <span className="font-medium mt-1">Destapaciones</span>
            </div>
          </div>

          <p className="text-gray-500 text-md mb-12 mt-20">
            … y más de 30 rubros que cubren todas las necesitades de tu hogar
          </p>
        </div>
      </section>

      <section className="bg-gradient-to-l from-tertiary to-quaternary py-20 text-center">
        <div className="container mx-auto px-4">
          <h2 className="mb-4 text-3xl md:text-4xl font-bold">
            Un servicio eficiente, confiable y personalizado
          </h2>
          <p className="mb-8 text-lg md:text-xl max-w-3xl mx-auto">
            En Soluciones Hogar trabajamos con técnicos verificados y te
            acompañamos en todo el proceso.
          </p>
          <SecondaryLink
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg bg-white px-8 py-4 text-lg font-semibold text-primary hover:bg-gray-100 transition"
          >
            <IconWhatsApp className="h-6 w-6" />
            Contactar ahora
          </SecondaryLink>
        </div>
      </section>

      <section className="py-36">
        <div className="container mx-auto px-4">
          <h2 className="mb-8 text-center text-3xl md:text-4xl font-bold text-gray-900">
            💬 Ellos ya probaron Soluciones Hogar
          </h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="border border-orange-200 bg-white p-6 rounded-lg shadow-sm"
              >
                <p className="mb-4 text-gray-700">"{t.text}"</p>
                <p className="font-semibold text-primary">
                  — {t.author}, {t.location}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer showWorkWithUs={false} />
      <WhatsAppFloating />
    </div>
  );
}
